import React from 'react';

import { Popover, PopoverCloseButton } from 'components';

import { GpsTrucksList } from './GpsTrucksList';

type SyncTrucksPopupProps = {
  isOpen: boolean;
  providerId: string;
  onClose: () => void;
};

export const SyncTrucksPopup: React.FC<SyncTrucksPopupProps> = ({
  isOpen,
  providerId,
  onClose,
}) => {
  return (
    <>
      {isOpen && (
        <Popover
          anchorEl={document.body}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          open={isOpen}
          slotProps={{
            paper: {
              style: {
                overflow: 'visible',
              },
            },
          }}
        >
          <PopoverCloseButton onClose={onClose} />
          <GpsTrucksList providerId={providerId} onClose={onClose} />
        </Popover>
      )}
    </>
  );
};
